import axios from 'axios';

export const logout = async () => {
  await axios.post('/ecpp/oauth/realms/main/logout');
  localStorage.clear();
  window.open('/', '_self');
  document.cookie = 'auth_session=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  document.cookie = 'access_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  document.cookie = 'refresh_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
};
